<form [formGroup]="queryForm">
  <div class="row">
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectDomain.value ? 'DOMAIN' : 'SELECT_DOMAIN') | translate }}</mat-label>
        <mat-select id="RecipesSearchDomainBtn" formControlName="domain" #selectDomain>
          <div id="RecipesSearchDomainLst">
            <mat-option [value]="null"></mat-option>
            <mat-optgroup *ngFor="let ssid of getDomainsSSID()" [label]="ssid">
              <mat-option *ngFor="let selection of filteredDomains[ssid] | sortBy : 'translatedName' : 'ASC'" [value]="selection">
                {{ selection.translatedName }}
              </mat-option>
            </mat-optgroup>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectMarket.value ? 'MARKET' : 'SELECT_MARKET') | translate }}</mat-label>
        <mat-select id="RecipesSearchMarketBtn" formControlName="market" [compareWith]="compareByKey" #selectMarket>
          <div id="RecipesSearchMarketLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of filteredMarkets | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ (selectLang.value ? 'LANGUAGE' : 'SELECT_LANGUAGE') | translate }}</mat-label>
        <mat-select id="RecipesSearchLangBtn" formControlName="lang" #selectLang>
          <div id="RecipesSearchLangLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of filteredLanguages | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ 'STATUT' | translate }}</mat-label>
        <mat-select id="RecipesSearchStatusBtn" formControlName="status" [compareWith]="compareByKey">
          <div id="RecipesSearchStatusLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of status | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l">
      <mat-form-field class="form-field-l">
        <mat-label>{{ 'communities.recipe.listing.SEARCH-REJECTION-REASON' | translate }}</mat-label>
        <mat-select id="RecipesSearchReasonsBtn" formControlName="lastModerationReason">
          <div id="RecipesSearchReasonsLst">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let selection of recipeReasons | sortBy : 'translatedName' : 'ASC'" [value]="selection">
              {{ selection.translatedName }}
            </mat-option>
          </div>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1 space-h-l"></div>
  </div>
  <app-recipe-search-bar class="search-bar" [fieldFilters]="fieldFilters" (searchBarChange)="searchAcp($event)"></app-recipe-search-bar>
</form>
